import {useTranslation} from "react-i18next";
import {useContext, useEffect, useRef, useState} from "react";
import {SwalAlertChoice, SwalAlertClass} from "core/swalClass";
import NavBreadcrum from "components/NavBreadcrum";
import AuthContext from "context/AuthContext";
import TopBarActions from "components/TopBarActions";
import ButtonsActions from "views/utils/buttonsActions";
import axiApi from "ApiCaller";
import TableOperationModes from "./ships/TableShip";
import navs from "./navs";
import FormShip from "./ships/FormShip";
import PreviewShip from "./ships/PreviewShip";
import {DeviceModeConfModel} from "site-apps/devices/DevicesModels";
import LoaderSpinner from "context/LoaderSpinner";
import ConditionalRender from "components/ConditionalRender";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ItemsModel from "core/itemsModel";
import OrderingModel from "components/ordering/OrderingModel";

const ViewProfilesShips = () => {
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tf} = useTranslation("forms");
    const title = _Tr("configuration.measures");
    const bread = [
        {
            name: _Tr("labels.device-configuration"),
            url: "/device-configuration/",
            current: false,
        },
        {name: title, current: true},
    ];
    document.title = title;
    const {user} = useContext(AuthContext);
    const [buttonsTB, setButtonsTB] = useState(() => {
        const buttonsAct = new ButtonsActions();
        buttonsAct.title = document.title;
        return buttonsAct;
    });
    const AlertQuestion = new SwalAlertChoice({
        icon: "info",
        iconColor: "#DD6B55",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: _Tf("labels.delete"),
        cancelButtonText: _Tf("labels.cancel"),
    });
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [itemsShown, setItemsShown] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [models, setModels] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    // variables form y prev
    const [item, setItem] = useState({...DeviceModeConfModel});
    const [showForm, setShowForm] = useState(false);
    const [showPreview, setShowPreview] = useState(false);

    const headersTable = [
        {name: _Tt("common.name"), attr: 0, direction: "asc", active: true, default: true},
        {name: _Tt("deviceModes.model"), attr: 1, direction: "asc", active: false},
    ];

    useEffect(() => {
        const buttons = {...buttonsTB};
        buttons.title = title;
        if (user.is_admin) {
            buttons.add.active = true;
            buttons.add.onClick = onClickAdd;
            buttons.add.disabled = false;
            buttons.edit.active = true;
            buttons.edit.onClick = onClickEdit;
            buttons.edit.disabled = items.current.chosen.length !== 1;
            buttons.delete.active = true;
            buttons.delete.onClick = onCLickDelete;
            buttons.delete.disabled = items.current.chosen.length === 0;
        }
        setButtonsTB(buttons);
        if (!pagerModelRef.current._initialized) {
            pagerModelRef.current.active = true;
            pagerModelRef.current.handleCallApi = () => {
                fetchModes();
            };
            orderingRef.current.setHeaders(headersTable);
            orderingRef.current.applyOrder = () => {
                fetchModes();
            };
            items.current.setItem = setItem;
            items.current.setShowPrev = setShowPreview;
            items.current.item = DeviceModeConfModel;
            fetchGetModes();
            pagerModelRef.current._initialized = true;
        }
    }, []);

    filters.current.filter = () => fetchModes();

    const fetchGetModes = async () => {
        setIsLoading(true);
        try {
            axiApi
                .get(`/api/devices/configs/ships/data/`)
                .then((resp) => {
                    if (resp.data) {
                        items.current.showed = [...resp.data.items];
                        setItemsShown([...resp.data.items]);
                        setModels(resp.data.models);

                        if (resp.data.pager) {
                            pagerModelRef.current.paging.update(resp.data.pager);
                        }
                    } else {
                        console.error("Error en ProfilesModes.api()");
                        Alert.warning("Error en el servicio", "No se han podido recuperar los modos");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    Alert.error("Error en el servidor", "Avise al administrador.");
                });
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchModes = async () => {
        try {
            axiApi
                .post(`/api/devices/configs/ships/data/`, filters.current.chosen, {
                    params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
                })
                .then((resp) => {
                    if (resp.data) {
                        items.current.setShowed(resp.data.items);
                        setItemsShown([...resp.data.items]);

                        if (resp.data.pager) {
                            pagerModelRef.current.paging.update(resp.data.pager);
                        }
                    } else {
                        console.error("Error en ProfilesModes.api()");
                        Alert.warning("Error en el servicio", "No se han podido recuperar los modos");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    Alert.error("Error en el servidor", "Avise al administrador.");
                });
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
        }
    };

    function onClickAdd() {
        // create a fresh item with values object (frontend reads exclusively from item.values)
        setItem({...DeviceModeConfModel});
        setShowForm(true);
        const b = {...buttonsTB};
        b.title = title;
        b.counter = items.current.all.length;
        setButtonsTB(b);
    }

    function onCLickDelete() {
        AlertQuestion.fire("Atención", "Se borrarán el modo o los modos selecionados").then((quest) => {
            if (quest.isConfirmed) {
                deleteItems();
            }
        });
    }

    function deleteItems() {
        let itemsDelete = items.current.getChosenIds();

        axiApi
            .post(`/api/devices/configs/ships/delete/`, {
                items: itemsDelete,
            })
            .then((r) => {
                if (r.data.status) {
                    items.current.all = items.current.all.filter((_item) => !itemsDelete.includes(_item.id));
                    items.current.showed = items.current.showed.filter((_item) => !itemsDelete.includes(_item.id));
                    setItemsShown([...items.current.showed]);
                    setShowForm(false);
                    items.current.clearChosen();
                    Alert.success("Operación realizada con éxito", "Los registros seleccionados se han eliminado correctamente");
                } else {
                    Alert.warning("Error en el servicio", "No se han podido borrar los datos");
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
                Alert.error("Error en el servidor", "Avise al administrador.");
            });
    }

    const onClickEdit = () => {
        if (items.current.chosen.length > 1) {
            return false;
        }
        let item_ = items.current.showed.find((item) => item.id === items.current.chosen[0]);
        setItem({...item_});
        setShowForm(true);
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <div className="row">
                <div className="col-md col-12">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableOperationModes
                            items={items}
                            itemsShow={itemsShown}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            checkAll={selectAll}
                            setCheckAll={setSelectAll}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
                <ConditionalRender condition={showPreview}>
                    <PreviewShip show={showPreview} item={item} />
                </ConditionalRender>
            </div>
            <FormShip
                show={showForm}
                setShow={setShowForm}
                item={item}
                models={models}
                items={items}
                setItemsShown={setItemsShown}
            />
        </>
    );
};
export default ViewProfilesShips;
